import "../assets/css/Siemens.css";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import data from "../../src/component/ApiUrl/meta_api";
import { Helmet } from "react-helmet";
import image1 from "../assets/img/products/Siemens/Precision Siemens SCADA Solutions -1.png";
import image2 from "../assets/img/products/Siemens/Precision Siemens SCADA Solutions -2.png";

function Siemens() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const SeimenMeta = data[0]?.Seimens_page;
    if (SeimenMeta) {
      setMeta(SeimenMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []); // Added data as a dependency// Added data as a dependency
  return (
    <>
      {/* <Helmet>
        <title>{meta ? meta.title : "About"}</title>
      </Helmet> */}
      {/* <!-- Page Header Start --> */}

      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <Helmet>
          <title>{meta ? meta.title : "Seimens - SKimitar Hindustan"}</title>
          <meta
            name="description"
            content="Learn about Skimitar Hindustan's PLC,HMI and Variable Frequency Drives in industrial automation solutions."
          />
        </Helmet>
        <div className="container py-5">
          <h1 className="display-3 text-white animated slideInRight">
            Siemens
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animated slideInRight mb-0">
              <li className="breadcrumb-item text-white-50">
                <Link to="/" className="">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item text-white">
                <Link to="/">Products</Link>
              </li>
              <li
                className="breadcrumb-item active text-white"
                aria-current="page"
              >
                Siemens
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container my-5">
        <div className="row align-items-center">
          {/* Text Section */}
          <div className="col-lg-6 col-md-6" data-aos="fade-right">
            <h1 className="text-danger text-gradient-primary fw-bold">
              Siemens PLC Solutions at Skimitar Automation
            </h1>
            <p className="text-justify centercardpara fs-6 justified-text">
              Skimitar Automation, we specialize in providing advanced Siemens
              PLC (Programmable Logic Controller) solutions that drive
              efficiency and innovation in industrial automation. Siemens PLCs
              are renowned for their robustness, flexibility, and scalability,
              making them ideal for a wide range of applications across various
              industries.
            </p>
          </div>

          {/* Image Section */}
          <div className="col-lg-6 col-md-6 text-center" data-aos="fade-left">
            <img
              className="about-image"
              src={require("../assets/img/products/Siemens/Siemens PLC Solutions.png")}
              style={{ height: "300px", width: "350px" }}
              alt="Who we are"
            />
          </div>
        </div>
      </div>

      <div className="container-fluid px-0 overflow-hidden">
        <div
          className="position-relative py-5"
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          }}
        >
          {/* Decorative elements */}
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background:
                "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxwYXR0ZXJuIGlkPSJwYXR0ZXJuIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHBhdHRlcm5UcmFuc2Zvcm09InJvdGF0ZSg0NSkiPjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNwYXR0ZXJuKSIvPjwvc3ZnPg==')",
              opacity: "0.6",
            }}
          ></div>

          <div className="container position-relative">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 order-lg-1 order-2">
                <div
                  className="position-relative rounded-4 overflow-hidden shadow-lg"
                  style={{
                    transform: "translateY(0)",
                    transition: "transform 0.5s ease",
                    animation: "float 6s ease-in-out infinite",
                  }}
                >
                  <img
                    className="img-fluid w-100"
                    src={require("../assets/img/products/Siemens/giphy.gif")}
                    alt="Siemens PLC Automation Process"
                    style={{
                      filter: "drop-shadow(0 10px 8px rgba(0,0,0,0.1))",
                    }}
                  />
                  <div className="position-absolute bottom-0 start-0 w-100 p-3 text-white">
                    <p className="mb-0 small fw-light text-danger">
                      Siemens PLC Industrial Automation
                    </p>
                  </div>
                </div>
              </div>

              {/* Text content - appears second on mobile */}
              <div className="col-lg-6 order-lg-2 order-1" data-aos="fade-left">
                <div className="ps-lg-5 position-relative">
                  {/* Premium decoration element */}
                  <div className="position-absolute top-0 start-0 h-100 w-4 bg-gradient-danger opacity-10 rounded-end"></div>

                  <h2 className="text-danger text-gradient-primary fs-3 fw-bold mb-4 d-flex align-items-center">
                    <span className="bg-danger bg-opacity-10 p-1 rounded-circle me-3 d-flex align-items-center justify-content-center">
                      <i className="bi bi-lightning-charge-fill text-danger"></i>
                    </span>
                    More Efficient E-Car Production
                  </h2>

                  <div className="pe-lg-4">
                    <ul className="list-unstyled mb-5">
                      <li className="mb-3 d-flex align-items-start">
                        <span className="me-3 text-danger mt-1">
                          <i className="bi bi-check-circle-fill fs-5"></i>
                        </span>
                        <span className="text-dark opacity-90">
                          <strong>Custom consultation</strong> and system design
                          tailored to your production needs
                        </span>
                      </li>
                      <li className="mb-3 d-flex align-items-start">
                        <span className="me-3 text-danger mt-1">
                          <i className="bi bi-check-circle-fill fs-5"></i>
                        </span>
                        <span className="text-dark opacity-90">
                          <strong>Seamless installation</strong> with minimal
                          downtime through precise planning
                        </span>
                      </li>
                      <li className="mb-3 d-flex align-items-start">
                        <span className="me-3 text-danger mt-1">
                          <i className="bi bi-check-circle-fill fs-5"></i>
                        </span>
                        <span className="text-dark opacity-90">
                          <strong>Precision programming</strong> for maximum
                          efficiency and throughput
                        </span>
                      </li>
                      <li className="mb-3 d-flex align-items-start">
                        <span className="me-3 text-danger mt-1">
                          <i className="bi bi-check-circle-fill fs-5"></i>
                        </span>
                        <span className="text-dark opacity-90">
                          <strong>Comprehensive testing</strong> and
                          commissioning with detailed reporting
                        </span>
                      </li>
                      <li className="mb-3 d-flex align-items-start">
                        <span className="me-3 text-danger mt-1">
                          <i className="bi bi-check-circle-fill fs-5"></i>
                        </span>
                        <span className="text-dark opacity-90">
                          <strong>Ongoing support</strong> with flexible
                          maintenance plans
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="container py-5 my-5">
        <div class="row justify-content-center mb-5">
          <div class="col-lg-8 text-center">
            <h2
              className="text-gradient-primary fw-bold fs-2 mb-1"
              data-aos="fade-left"
            >
              Our HMI Services
            </h2>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
                  <img
                    src={require(`../assets/img/products/Siemens/6.jpg`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Consultation"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-users text-danger"
                        >
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">
                        Consultation & System Design
                      </h3>
                    </div>
                    <p class="fs-6 mb-0">
                      Our experienced team works closely with you to assess your
                      automation needs and design a customized HMI solution that
                      maximizes operational efficiency.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
                 
                  <img
                    src={require(`../assets/img/products/Siemens/7.jpg`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Configuration"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-code text-danger"
                        >
                          <polyline points="16 18 22 12 16 6"></polyline>
                          <polyline points="8 6 2 12 8 18"></polyline>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">
                        Configuration & Programming
                      </h3>
                    </div>
                    <p class="fs-6 mb-0">
                      Our skilled engineers specialize in configuring Siemens
                      HMIs with precision programming to meet your unique
                      operational requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
               
                  <img
                    src={require(`../assets/img/products/Siemens/7.jpg`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Maintenance"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-tool text-danger"
                        >
                          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">
                        Maintenance & Upgrades
                      </h3>
                    </div>
                    <p class="fs-6 mb-0">
                      We provide comprehensive maintenance plans and seamless
                      upgrade services to keep your HMI systems running at peak
                      performance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
                 
                  <img
                    src={require(`../assets/img/products/Siemens/9.jpg`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Testing"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-check-circle text-danger"
                        >
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                          <polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">
                        Testing & Validation
                      </h3>
                    </div>
                    <p class="fs-6 mb-0">
                      We conduct rigorous testing and validation protocols to
                      ensure your HMI system meets all performance and safety
                      standards before deployment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div class="container py-5 my-5">
        <div class="row justify-content-center mb-5">
          <div class="col-lg-8 text-center">
            <h2
              className="text-gradient-primary fw-bold fs-2 mb-1"
              data-aos="fade-left"
            >
              Our HMI Services
            </h2>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
                  <img
                    src={require(`../assets/img/products/Siemens/Basic Panels Our.png`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Consultation"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-users text-danger"
                        >
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">Basic Panels</h3>
                    </div>
                    <p class="fs-6 mb-0 justified-text">
                      Our experienced team works closely with you to assess your
                      automation needs and design a customized HMI solution that
                      maximizes operational efficiency.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Service 2 --> */}
          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
                  {/* <img src="../assets/img/products/Siemens/7.jpg" class="img-fluid h-100 w-100 object-cover" alt="Configuration"> */}
                  <img
                    src={require(`../assets/img/products/Siemens/comfort panel our.png`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Configuration"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-code text-danger"
                        >
                          <polyline points="16 18 22 12 16 6"></polyline>
                          <polyline points="8 6 2 12 8 18"></polyline>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">Comfort Panels</h3>
                    </div>
                    <p class="fs-6 mb-0 justified-text">
                      Our skilled engineers specialize in configuring Siemens
                      HMIs with precision programming to meet your unique
                      operational requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Service 3 --> */}
          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
                  {/* <img src="../assets/img/products/Siemens/8.jpg" class="img-fluid h-100 w-100 object-cover" alt="Maintenance"> */}
                  <img
                    src={require(`../assets/img/products/Siemens/Mobile Panels We.png`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Maintenance"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-tool text-danger"
                        >
                          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">Mobile Panels</h3>
                    </div>
                    <p class="fs-6 mb-0 justified-text">
                      We provide comprehensive maintenance plans and seamless
                      upgrade services to keep your HMI systems running at peak
                      performance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Service 4 --> */}
          <div class="col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden transition-all hover-shadow">
              <div class="row g-0 h-100">
                <div class="col-md-5">
                  {/* <img src="../assets/img/products/Siemens/9.jpg" class="img-fluid h-100 w-100 object-cover" alt="Testing"> */}
                  <img
                    src={require(`../assets/img/products/Siemens/Unified Comfort Panels.png`)}
                    class="img-fluid h-100 w-100 object-cover"
                    alt="Testing"
                  ></img>
                </div>
                <div class="col-md-7">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-check-circle text-danger"
                        >
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                          <polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                      </div>
                      <h3 class="h5 fw-bold mb-0 text-dark">
                        Unified Comfort Panels
                      </h3>
                    </div>
                    <p class="fs-6 mb-0 justified-text">
                      We conduct rigorous testing and validation protocols to
                      ensure your HMI system meets all performance and safety
                      standards before deployment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- CTA --> */}
      </div>

      <div className="container-fluid bg-light ">
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="p-4 p-md-5 bg-white rounded-4 shadow-sm position-relative overflow-hidden">
                <h4
                  className="text-gradient-primary fw-bold fs-2 mb-4"
                  data-aos="fade-left"
                >
                  Precision Siemens SCADA Solutions
                </h4>
                <p className="lead text-dark fs-6 mb-4 position-relative justified-text">
                  Elevate your industrial automation with our cutting-edge
                  Siemens SCADA expertise. We deliver comprehensive solutions
                  that integrate seamlessly with your existing infrastructure.
                </p>

                {/* Additional features list */}
                <ul className="list-unstyled mb-4">
                  <li className="mb-2 d-flex align-items-start">
                    <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                    <span>Real-time monitoring & control</span>
                  </li>
                  <li className="mb-2 d-flex align-items-start">
                    <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                    <span>Seamless system integration</span>
                  </li>
                  <li className="d-flex align-items-start">
                    <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                    <span>Performance optimization</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Image Gallery Column */}
            <div className="col-lg-6">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="overflow-hidden rounded-4 shadow-sm h-100">
                    <img
                      src={image1}
                      alt="SCADA System Interface"
                      className="img-fluid w-100 h-100 object-fit-cover"
                      style={{ minHeight: "250px" }}
                    />
                    <div className="p-3 bg-white">
                      <h6 className="fw-bold">Custom HMI Interfaces</h6>
                      <small className="text-muted">
                        Intuitive operator controls
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="overflow-hidden rounded-4 shadow-sm h-100">
                    <img
                      src={image2}
                      alt="Industrial Automation"
                      className="img-fluid w-100 h-100 object-fit-cover"
                      style={{ minHeight: "250px" }}
                    />
                    <div className="p-3 bg-white">
                      <h6 className="fw-bold">Industrial Integration</h6>
                      <small className="text-muted">
                        Seamless PLC connectivity
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid py-5 bg-light">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-5" data-aos="fade-right">
              <div className="overflow-hidden rounded-4 shadow-lg">
                <img
                  className="img-fluid w-100 zoom-hover"
                  src={require("../assets/img/products/Siemens/Frequency Drives (VFD) Solutions-1.png")}
                  alt="Frequency Drives Solutions"
                />
              </div>
            </div>

            <div className="col-lg-7" data-aos="fade-left">
              <div className="">
                <h2
                  className="text-gradient-primary fw-bold fs-2 mb-3"
                  data-aos="fade-left"
                >
                  Frequency Drives (VFD) Solutions
                </h2>
                <div className="bg-white p-4 rounded-4 shadow-sm">
                  <p className="fs-6 text-dark mb-4">
                    Skimitar Automation, we provide comprehensive Siemens VFD
                    technology solutions tailored to your needs.
                  </p>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <h5 className="text-danger fw-bold mb-3">
                          Consultation & Design
                        </h5>
                        <p className="mb-0">
                          Tailored VFD solutions for optimal performance
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <h5 className="text-danger fw-bold mb-3">
                          Installation
                        </h5>
                        <p className="mb-0">
                          Professional setup and commissioning
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <h5 className="text-danger fw-bold mb-3">
                          Maintenance
                        </h5>
                        <p className="mb-0">
                          Ongoing support to minimize downtime
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <h5 className="text-danger fw-bold mb-3">Training</h5>
                        <p className="mb-0">
                          Empower your staff with VFD knowledge
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container pt-2 mb-5">
        <div className="row">
          <div className="col-lg-4">
            <div class="motors-grid">
              <div class="motor-card">
                <h3>General-Purpose Motors</h3>
                <span class="motor-code">SIMOTICS GP</span>
                <p className="fs-6">
                  Standard motors for industrial applications with reliable
                  performance and versatility.
                </p>
              </div>
              <div class="motor-card">
                <h3>Severe-Duty Motors</h3>
                <span class="motor-code">SIMOTICS SD</span>
                <p className="fs-6">
                  Heavy-duty motors designed to withstand harsh and challenging
                  industrial environments.
                </p>
              </div>
              <div class="motor-card">
                <h3>Explosion-Proof Motors</h3>
                <span class="motor-code">SIMOTICS XP</span>
                <p className="fs-6">
                  Specialized motors engineered for hazardous and potentially
                  explosive industrial areas.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="row mt-5">
              <div
                className="col-lg-10 d-flex justify-content-center mt-5"
                data-aos="fade-left"
              >
                <img
                  className="Automation-Ahead1"
                  src={require("../assets/img/products/Siemens/Motors -1.png")}
                  alt="Image 1"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div class="motors-grid">
              <div class="motor-card">
                <h3>Servo Motors</h3>
                <span class="motor-code">SIMOTICS S / 1FK2</span>
                <p className="fs-6">
                  High-precision motion control motors with exceptional dynamic
                  response capabilities.
                </p>
              </div>
              <div class="motor-card">
                <h3>DC Motors</h3>
                <span class="motor-code">SIMOTICS DC</span>
                <p className="fs-6">
                  Industrial DC motors providing consistent and controllable
                  power for specific applications.
                </p>
              </div>
              <div class="motor-card">
                <h3>High-Voltage Motors</h3>
                <span class="motor-code">SIMOTICS HV</span>
                <p className="fs-6">
                  Robust high-voltage motors designed for large-scale industrial
                  operations and power systems.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  */}
    </>
  );
}

export default Siemens;
